import "./styles.scss";

import { useTranslation } from "react-i18next";
import moment from "moment";

import { useNotifications } from "context/notifications";

import ModalNew from "components/ModalNew";
import SelectablePill from "components/SelectablePill";
import StatusPill from "components/StatusPill";
import Button from "components/Button";

import {
  getNotificationTitle,
  isNewTaskNotification,
} from "libs/notification_render";

const mainClass = "notifications-modal";

const NotificationsModal = ({ userType, data, setWebsiteInfoId, onClose }) => {
  const { t } = useTranslation();
  const { allData: notifications, readHandler } = useNotifications();

  const notification = notifications?.find((item) => item?._id === data.id);

  const taskAddedToUser = notification?.template === 21;
  const newWebsiteComment =
    notification?.template === null || notification?.template === 24;
  const type =
    notification?.template === 17 ||
    notification?.template === 18 ||
    notification?.template === 19 ||
    notification?.template === 20 ||
    taskAddedToUser
      ? "task"
      : notification?.template === 28
        ? "register"
        : "website";

  const title = getNotificationTitle(notification || {}, t);
  const hasTaskDescription =
    isNewTaskNotification(notification?.template) && !!data?.task?.description;
  const date = moment(notification?.created_at)?.format("ll");
  const website = notification?.website?.website;
  const status = notification?.status;

  return (
    <ModalNew
      title={title}
      variant="wide"
      isOpen={!!notification}
      isSubmitHidden
      onClose={onClose}
    >
      <div className={mainClass}>
        <div className={`${mainClass}__meta`}>
          <div>
            <p>{t("Date")}</p>
            <span>{date}</span>
          </div>
          {website && (
            <div>
              <p>{t("Website [SHORT]")}</p>
              <span>{website}</span>
            </div>
          )}
          <div>
            <p>{t("Category")}</p>
            <SelectablePill
              data={{
                label: t(
                  type === "task"
                    ? "Task"
                    : type === "register"
                      ? "Registration"
                      : "Website [SHORT]",
                ),
                color:
                  type === "task"
                    ? "yellow"
                    : type === "register"
                      ? "blue"
                      : "green",
              }}
            />
          </div>
          <div>
            <p>Status</p>
            <StatusPill
              active={!!status}
              onClick={() => readHandler(data?.id, status === 1 ? 0 : 1)}
            />
          </div>
        </div>
        <div className={`${mainClass}__content`}>
          <p className={`${mainClass}__content-title`}>
            {hasTaskDescription ? t("Task description") : t("Message")}
          </p>
          {hasTaskDescription ? (
            <p dangerouslySetInnerHTML={{ __html: data.task?.description }} />
          ) : (
            data?.text && <p dangerouslySetInnerHTML={{ __html: data.text }} />
          )}
        </div>
      </div>
      {(newWebsiteComment
        ? notification?.website?._id
        : data?.href && data.href.indexOf("undefined") === -1) && (
        <div className={`${mainClass}__cta`}>
          <Button
            href={
              newWebsiteComment
                ? userType === "client"
                  ? notification?.website?._id
                    ? `/websites/${notification?.website?._id}`
                    : undefined
                  : undefined
                : taskAddedToUser
                  ? data.href.replace("websites", "tasks")
                  : data.href
            }
            onClick={() => {
              if (newWebsiteComment && userType !== "client") {
                if (typeof setWebsiteInfoId === "function")
                  setWebsiteInfoId(notification?.website?._id);

                onClose();
              }
            }}
          >
            {t(
              `Go to ${type === "task" ? "task" : type === "register" ? "registration" : "website"} details`,
            )}
          </Button>
        </div>
      )}
    </ModalNew>
  );
};

export default NotificationsModal;
